import { ComponentType } from '@angular/cdk/overlay';
import { DOCUMENT } from '@angular/common';
import { computed, inject, Injectable, signal, Signal, WritableSignal } from '@angular/core';
import { DialogService } from '../dialog';
import {
  errorPageContent,
  MAINTENANCE_COMPONENT_TYPE,
  MaintenancePageModel,
  MaintenanceType,
  toEarlyPageContent,
} from './maintenance.model';

/* eslint-disable @typescript-eslint/member-ordering */

@Injectable({ providedIn: 'root' })
export class MaintenanceService {
  private readonly dialogService: DialogService = inject(DialogService);
  private readonly maintenanceComponentType: ComponentType<unknown> = inject(MAINTENANCE_COMPONENT_TYPE);
  private readonly document: Document = inject(DOCUMENT);

  private readonly _maintenanceModeEnabled: WritableSignal<boolean> = signal(false);
  public readonly maintenanceModeEnabled: Signal<boolean> = computed(() => this._maintenanceModeEnabled());

  public setMaintenanceMode(enabled: boolean, type?: MaintenanceType): void {
    this.dialogService.closeAll();
    this._maintenanceModeEnabled.set(enabled);

    if (enabled) {
      this.openMaintenanceOverlay(type);
    } else {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.document.defaultView!.location.reload();
    }
  }

  private openMaintenanceOverlay(type?: MaintenanceType): void {
    this.dialogService.open(this.maintenanceComponentType, {
      closeOnNavigation: false,
      disableClose: true,
      hasBackdrop: true,
      data: this.getPageContentByType(type),
      width: '100vw',
      height: '100vh',
      minWidth: '100vw',
      minHeight: '100vh',
      panelClass: 'fullscreen-dialog',
    });
  }

  private getPageContentByType(type?: MaintenanceType): MaintenancePageModel | undefined {
    switch (type) {
      case 'error':
        return errorPageContent;
      case 'tooEarly':
        return toEarlyPageContent;
      default:
        return undefined;
    }
  }
}
